import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

const inputCls =
  "w-full border border-engraved bg-paper px-4 py-3 text-sm text-ink outline-none transition-colors focus:border-navy";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="paper-grain flex min-h-screen items-center justify-center bg-paper px-4" data-testid="admin-login-page">
      <div className="engraved-frame w-full max-w-sm bg-white p-10 shadow-elevated">
        <img src="/dv-mark.png" alt="DV Luxury Realty" className="mx-auto h-14 w-14" />
        <h1 className="mt-6 text-center font-serif text-2xl font-bold text-navy">Agent Portal</h1>
        <p className="mt-1 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
          The Valdivieso Group
        </p>

        {error && (
          <p data-testid="admin-login-error" className="mt-5 border border-crimson/30 bg-crimson/5 px-4 py-2.5 text-center text-xs font-medium text-crimson">
            {error}
          </p>
        )}

        <form onSubmit={submit} className="mt-7 space-y-4">
          <input data-testid="admin-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <input data-testid="admin-password-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          <button
            data-testid="admin-login-button"
            disabled={loading}
            className="w-full bg-navy px-6 py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-crimson disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <Link to="/" data-testid="admin-login-back-link" className="mt-6 block text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500 hover:text-crimson">
          Return to Site
        </Link>
      </div>
    </div>
  );
};

export default AdminLogin;
